<template>
  <div class="desktop-main">
    <div class="right">
      <div class="main-line">
        本软件尊重并保护所有用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本软件会按照本隐私权政策的规定使用您的个人信息。但本软件将非常审慎地对待这些信息。除本隐私权政策规定外，在未征得您预先许可的情况下，本软件不会将这些信息对外披露或向第三方提供。本隐私权政策会不定期更新。您在同意本软件服务使用协议时，即视为您已经同意本隐私权政策全部内容，因为本隐私权政策属于本软件服务使用协议不可分割的一部分。
      </div>
      <div class="title-line">
        1.适用范围
      </div>
      <div class="main-line">
        在您使用本软件服务时，本软件自动接收并记录您手机上的信息，包括但不限于您使用的语言、访问日期和时间、软硬件特征信息及您需求的查询记录等数据；
      </div>
      <div class="title-line">
        2.信息的使用
      </div>
      <div class="main-line">
        在获得您的数据之后，本软件会将其上传至服务器，以便您能够更好地使用服务。
      </div>
      <div class="title-line">
        3.信息披露
      </div>
      <div class="main-line">
        <p>a)本软件不会将您的信息披露给不受信任的第三方。</p>
        <p>b)根据法律的有关规定，或者司法或行政机构的要求，向第三方或者司法、行政机构披露；</p>
        <p>c)如您出现违反中国有关法律、法规或者相关规定的情况，需要向第三方披露。</p>
      </div>
      <div class="title-line">
        4.信息存储和交换
      </div>
      <div class="main-line">
        本软件收集的有关您的信息和资料将保存在本软件公司的服务器上，这些信息和资料可能传送至您所在国家司法、行政机构。
      </div>
      <div class="title-line">
        5. 信息安全
      </div>
      <div class="main-line">
        本应用账号均有安全保护功能，请妥善保管您的用户名及密码。本应用将通过对用户密码进行加密等安全措施确保您的信息不泄露。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“绝对无漏洞的安全措施”。
      </div>
      <div class="bottom-line">环保小智开发和运维团队</div>
      <div class="bottom-line">2020年04月18日</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.desktop-main {
  padding-top: 20px;
  .main-line {
    text-indent: 2em;
    margin-bottom: 8px;
  }
  .title-line {
    font-size: 32rpx;
    font-weight: bold;
    margin-top: 16rpx;
  }
  .bottom-line {
    text-align: right;
    color: #83889a;
  }
}
</style>
